import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CustomNextArrow, CustomPrevArrow } from "../../utility/CustomArrow";
import axios from "axios";
import API_URL from "../../../config";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${API_URL}/layout/blogs?page=1&limit=6`)
      .then((response) => {
        setBlogs(response.data?.data || []);
      })
      .catch((error) => {
        console.error("Error fetching blog data:", error);
      });
  }, []);

  const settings = {
    infinite: blogs?.length > 1,
    dots: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 3, slidesToScroll: 1 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  };

  const handleViewDetails = (blog) => {
    navigate("/blog-details", { state: { blog } });
  };

  return (
    <section className="py-5">
      <div className="container">
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.7 }}
          className="text-center mb-5"
        >
          <h2 className="fw-bold" style={{ color: "#c69933", fontSize: "3rem" }}>
            Latest Posts & Articles
          </h2>
        
        </motion.div>

        {/* Blog Slider */}
        {blogs?.length > 0 ? (
          <Slider {...settings} className="slick-slider">
            {blogs.map((post) => (
              <motion.div
                key={post?.id || Math.random()}
                className="p-3"
                whileHover={{ y: -5 }}
                transition={{ duration: 0.3 }}
              >
                <div
                  onClick={() => handleViewDetails(post)}
                  style={{
                    display: "block",
                    height: "100%",
                    textDecoration: "none",
                    color: "inherit",
                    cursor: "pointer",
                  }}
                  aria-label={`Read more about ${post?.title || "this post"}`}
                >
                  <div className="card h-100 shadow-sm d-flex flex-column border-0 overflow-hidden">
                    <div className="position-relative overflow-hidden">
                      <img
                        src={post?.thumbnail || "/assets/default-thumbnail.jpg"}
                        alt={post?.title || "Post Thumbnail"}
                        className="card-img-top p-2 shadow-sm"
                        style={{
                          height: "15rem",
                          width: "100%",
                          objectFit: "cover",
                        }}
                        loading="lazy"
                      />
                    </div>

                    <div className="card-body d-flex flex-column">
                      <h5
                        className="card-title fw-semibold"
                        style={{
                          minHeight: "4em",
                          overflow: "hidden",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        {post?.title || "Untitled Post"}
                      </h5>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </Slider>
        ) : (
          <div className="text-center py-4">
            <p className="text-muted">No posts found</p>
          </div>
        )}
      </div>

      <hr
        className="mt-5 mx-auto"
        style={{
          height: "1px",
          backgroundColor: "#b78c35",
          border: "none",
          maxWidth: "1200px",
        }}
      />
    </section>
  );
};

export default Blogs;
